export default __webpack_public_path__ + "static/media/linkedin.4718d831.svg";